module.exports = __webpack_public_path__ + "static/media/location-maps-letter-e-arrow.39aa096b.png";